// Honeypot field — a real text input, hidden from sighted users via
// CSS (not type="hidden", which some bots skip) and from screen
// readers via aria-hidden. Real users never see or fill this in; a
// script that blindly fills every input on the page will. Paired
// with useFormTiming() for a second, independent spam signal.
const Honeypot = ({ value, onChange }) => (
  <div style={{ position: "absolute", left: "-9999px", top: "auto", width: "1px", height: "1px", overflow: "hidden" }} aria-hidden="true">
    <label htmlFor="company_website">Company Website</label>
    <input
      id="company_website"
      name="company_website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={onChange}
    />
  </div>
);

export default Honeypot;
